module.exports = __webpack_public_path__ + "static/media/marca.9db1f0bd.svg";